import { useHandler } from "@redotech/react-util/hook";
import {
  NumberComparisonOperator,
  numberComparisonOperators,
  numberComparisonToLabel,
} from "@redotech/redo-model/advanced-flow/expressions/number-expression";
import {
  OmsAvailableInventoryConditionStep,
  OmsCustomAttributeNumber1ConditionStep,
  OmsCustomAttributeNumber2ConditionStep,
  OmsCustomAttributeNumber3ConditionStep,
  OmsCustomerOrderCountConditionStep,
  OmsCustomNumber1ConditionStep,
  OmsCustomNumber2ConditionStep,
  OmsCustomNumber3ConditionStep,
  OmsItemAmountConditionStep,
  OmsItemQuantityConditionStep,
  OmsPackageWeightOzConditionStep,
  OmsTaxesPaidConditionStep,
  OmsTotalValueConditionStep,
} from "@redotech/redo-model/advanced-flow/oms/conditions";
import { OmsConditionStep } from "@redotech/redo-model/advanced-flow/steps";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { memo } from "react";
import { DeepPartial } from "..";
import { NumberMatchKindSelect } from "../common/number-match-kind-select";

const numericCompareOptions: RedoListItem<NumberComparisonOperator>[] =
  numberComparisonOperators.map((type) => ({
    value: type,
    type: "text",
    id: type,
    text: numberComparisonToLabel[type],
  }));

export const OmsNumberMatchTypeSelect = memo(function NumberMatchTypeSelect({
  step,
  setStep,
}: {
  step:
    | DeepPartial<OmsTotalValueConditionStep>
    | DeepPartial<OmsTaxesPaidConditionStep>
    | DeepPartial<OmsPackageWeightOzConditionStep>
    | DeepPartial<OmsItemQuantityConditionStep>
    | DeepPartial<OmsItemAmountConditionStep>
    | DeepPartial<OmsAvailableInventoryConditionStep>
    | DeepPartial<OmsCustomNumber1ConditionStep>
    | DeepPartial<OmsCustomNumber2ConditionStep>
    | DeepPartial<OmsCustomNumber3ConditionStep>
    | DeepPartial<OmsCustomAttributeNumber1ConditionStep>
    | DeepPartial<OmsCustomAttributeNumber2ConditionStep>
    | DeepPartial<OmsCustomAttributeNumber3ConditionStep>
    | DeepPartial<OmsCustomerOrderCountConditionStep>;
  setStep: (step: DeepPartial<OmsConditionStep>) => void;
}) {
  const setMatchType = useHandler((item: NumberComparisonOperator) => {
    setStep({ ...step, matchType: item });
  });
  return (
    <NumberMatchKindSelect<NumberComparisonOperator>
      options={numericCompareOptions}
      selectedMatchKind={
        numericCompareOptions.find((o) => o.id === step.matchType)?.value
      }
      setMatchKind={setMatchType}
    />
  );
});
